import { Form, reduxForm } from 'redux-form';
import React, { ChangeEvent } from 'react';

import { AppCheckboxField } from 'components/form/appCheckboxField';
import styles from './EventFilters.module.scss';
import { FiltersFormProps, FiltersFormState } from './EventFilters.types';

export class EventFilters extends React.Component<FiltersFormProps, FiltersFormState> {
  constructor(props: any) {
    super(props);

    this.state = {
      active: true,
      archived: false,
    };
  }

  componentDidUpdate() {
    const { onFilters } = this.props;
    onFilters(this.state);
  }

  render() {
    const { className } = this.props;
    const { active, archived } = this.state;

    return (
      <div className={className}>
        <Form onSubmit={() => undefined} className={styles.filterContainer}>
          <div className={styles.filterHeader}>Event status</div>
          <AppCheckboxField
            name="active"
            label="Active"
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ active: e.target.checked })}
            value={active}
            className={styles.filter}
          />
          <AppCheckboxField
            name="archived"
            label="Archived"
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ archived: e.target.checked })}
            className={styles.filter}
            value={archived}
          />
        </Form>
      </div>
    );
  }
}

export const FiltersFormContainer = reduxForm<any, any>({
  form: 'participantFilters',
})(EventFilters);
